<p>✍️ Măsurătorile trebuie să fie în metri (ex. 12.55 metri)</p>
<p *ngIf="roofType !== roofTypes.FenceSlat">👉 Pierderile sunt calculate automat (unde e cazul) și incluse în suprafața finală</p>
<custom-shape *ngIf="roofType === roofTypes.CustomShape" (eventEmitter)="setMeasurements($event)"
              [initData]="activeCalculation.measurements"></custom-shape>

<div class="step-1" *ngIf="roofType !== roofTypes.CustomShape">
  <div class="one-column">
    <one-slope *ngIf="roofType === roofTypes.OneSlope" (eventEmitter)="setMeasurements($event)" [roofType]="roofType"
               [initData]="activeCalculation.measurements"></one-slope>
    <one-slope *ngIf="roofType === roofTypes.TwoSlopes" (eventEmitter)="setMeasurements($event)" [roofType]="roofType"
               [initData]="activeCalculation.measurements"></one-slope>
    <four-slopes *ngIf="roofType === roofTypes.FourSlopes" (eventEmitter)="setMeasurements($event)"
                 [initData]="activeCalculation.measurements"></four-slopes>
    <fence-slat-calculation *ngIf="roofType === roofTypes.FenceSlat" [initData]="activeCalculation.measurements" (eventEmitter)="setMeasurements($event)"></fence-slat-calculation>
    <ng-container *ngIf="roofType !== roofTypes.FenceSlat">
      <mat-checkbox color="primary" matTooltip="Vă vom calcula necesarul și pentru sistemul pluvial" [checked]="rainSystem" (change)="changeRainSystemToggle($event.checked)">
        <span class="prevent-select">Vreau sistem pluvial</span>
      </mat-checkbox>
      <rain-system-measurements *ngIf="rainSystem" (eventEmitter)="setRainSystem($event)" [initData]="this.activeCalculation.rainSystem"></rain-system-measurements>
    </ng-container>
  </div>

  <div class="second-column" style="text-align: center">
    <img *ngIf="roofType === roofTypes.OneSlope" src="./assets/calculation-types/acoperis-1-apa.svg" alt="schita 1 apa" />
    <img *ngIf="roofType === roofTypes.TwoSlopes" src="./assets/calculation-types/acoperis-2-ape.svg" alt="schita 2 ape" />
    <img *ngIf="roofType === roofTypes.FourSlopes" src="./assets/calculation-types/acoperis-4-ape.svg" alt="schita 4 ape" />
    <img *ngIf="roofType === roofTypes.FenceSlat" src="./assets/calculation-types/fence-slat.webp" alt="schita sipca gard" />
  </div>
  <div id="annexesContainer" *ngIf="roofType !== roofTypes.FenceSlat">
    <button mat-raised-button color="primary" gaEvent="measurements_add_annex" gaCategory="buttons_tracking" (click)="openDialog()">
      <mat-icon matPrefix>add</mat-icon>
      Adaugă o anexă
    </button>
    <p>Anexele pot fi terase, garaje, extinderi sau chiar un acoperiș separat.</p>
    <ng-container *ngIf="activeCalculation?.annexes?.length">
      <mat-card appearance="outlined" *ngFor="let annex of activeCalculation.annexes; let i = index;" class="card-radius card-container">
        <mat-card-content class="content">
          <p>
            Anexa {{i + 1}} - {{roofTypesLocalized[annex.roofType]}} - {{annex.name}}
          </p>
          <mat-card-footer>
            <button mat-button gaEvent="delete_annex" gaCategory="buttons_tracking" (click)="removeAnnex(i)">
              <mat-icon matPrefix>delete_outline</mat-icon>
              Șterge
            </button>
            <button mat-button gaEvent="edit_annex" gaCategory="buttons_tracking" (click)="openDialog(i)">
              <mat-icon matPrefix>edit</mat-icon>
              Modifică
            </button>
          </mat-card-footer>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </div>
  <mat-card id="contactCard" appearance="outlined" class="card-radius radio-container">
    <mat-card-header>
      <h2 class="card-header">Ai întrebări?</h2>
    </mat-card-header>
    <mat-card-content>
      <p>Ne poți contacta la telefon/whatsapp la <a (click)="trackConversion('Pv7pCN3In6QZELWMoq4q')" href="tel:0740101510">0740 101 510</a>, pe email <a
        href="mailto:vanzari@experttabla.ro">vanzari@experttabla.ro</a> sau click pe butonul de mai jos si te vom
        contacta noi</p>
      <button class="mb-8 full-width" color="primary" mat-raised-button gaEvent="measurements_contact_me"
              gaCategory="buttons_tracking" (click)="openContactMeDialog()">
        <mat-icon>contact_phone</mat-icon>
        Vreau să fiu contactat
      </button>
    </mat-card-content>
  </mat-card>
</div>

<step-navigation [disabled]="!measurementsFormEvent.valid || !rainSystemFormEvent.valid" (forwardClickEmitter)="setCalculateAccessories()"></step-navigation>

